// extracted by css-extract-rspack-plugin
export default {"searchFeaturedSection":"SearchFeaturedBlogs-module__searchFeaturedSection","mobileCardWrapper":"SearchFeaturedBlogs-module__mobileCardWrapper"};